module.exports = __webpack_public_path__ + "img/mapa_shake.4f6fc2cc.svg";